import { render, staticRenderFns } from "./SearchbarSuggestionEntry.vue?vue&type=template&id=bb76e404&scoped=true&"
import script from "./SearchbarSuggestionEntry.vue?vue&type=script&lang=ts&"
export * from "./SearchbarSuggestionEntry.vue?vue&type=script&lang=ts&"
import style0 from "./SearchbarSuggestionEntry.vue?vue&type=style&index=0&id=bb76e404&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb76e404",
  null
  
)

export default component.exports